import React from 'react';
import Highlighter from './Highlighter';
export default {
    title: 'Components/Highlighter',
    component: Highlighter,
};
const Template = (args) => React.createElement(Highlighter, { ...args });
const children = 'This is a sentence.';
export const Default = Template.bind({});
Default.args = {
    children,
    search: '',
};
export const Highlighted = Template.bind({});
Highlighted.args = {
    children,
    search: 'sent',
};
